"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var simple = require("simple-encryptor");
var common_1 = require("./utils/common");
var machineId_1 = require("./utils/machineId");
var networkId_1 = require("./utils/networkId");
var Cpass = (function () {
    function Cpass(masterKey) {
        if (typeof masterKey !== 'undefined' && masterKey !== null) {
            this.machineId = common_1.hash(masterKey);
        }
        else {
            this.machineId = this.getMachineId();
        }
        this.encryptor = this.encryptor || simple(this.machineId);
    }
    Cpass.prototype.encode = function (unsecured) {
        var secured;
        secured = this.encryptor.encrypt(unsecured);
        return secured;
    };
    Cpass.prototype.decode = function (secured) {
        var unsecured;
        unsecured = this.encryptor.decrypt(secured);
        return unsecured || secured;
    };
    Cpass.prototype.getMachineId = function () {
        var mId;
        try {
            mId = machineId_1.machineIdSync(false);
        }
        catch (ex) {
            mId = networkId_1.networkId(false);
        }
        return mId;
    };
    return Cpass;
}());
exports.Cpass = Cpass;
//# sourceMappingURL=Cpass.js.map